export const environment = {
  isProduction: false,
  name: "LOCAL",
  basePath: 'https://api.carvia-test.org/vendor-service',
  domainBaseUri: '.carvia-test.org'

};
